<form [formGroup]="form">
  <ng-container>
    <div
      class="mbs-form-group_content"
      formGroupName="managedSystem">
      <mbs-switcher
        [label]="'shared:agentOptions.allowRemoteAccess' | i18next"
        formControlName="allowRemoteConnection"></mbs-switcher>
    </div>
  </ng-container>

  <ng-container
    [ngTemplateOutlet]="sectionTitle"
    [ngTemplateOutletContext]="{
      title: 'shared:agentOptions.connectOptions.access' | i18next,
      withoutSeparator: true
    }">
  </ng-container>

  <ng-container formGroupName="managedSystem">
    <div class="mbs-form-group_content">
      <mbs-checkbox
        [label]="'shared:agentOptions.connectOptions.securityAllowRaUnattendedAccessLabel' | i18next"
        formControlName="allowRAUnattendedAccess">
        <ng-container appendLabel>
          <span
            class="ico ico-info-circle tooltip-btn text-info"
            [ngbTooltip]="'shared:agentOptions.connectOptions.securityAllowRaUnattendedAccessInfoText' | i18next"
            container="body">
          </span>
        </ng-container>
      </mbs-checkbox>
    </div>
  </ng-container>

  <ng-container formGroupName="security">
    <ng-container formGroupName="customPassword">
      <mbs-checkbox
        class="mt-2"
        [label]="'shared:agentOptions.connectOptions.securityUnattendedAccessLabel' | i18next"
        formControlName="enabled"></mbs-checkbox>
      <div
        class="row mt-2"
        *ngIf="isUnattendedAccessPasswordVisible()">
        <div class="col-9">
          <mbs-input
            [autocomplete]="'off'"
            [name]="'unattendedAccessPassword'"
            [type]="unattendedPasswordInputType"
            [placeholder]="'shared:agentOptions.connectOptions.passwordInputPlaceholder' | i18next"
            (buttonClick)="unattendedPasswordInputType = getPasswordInputType(unattendedPasswordInputType)"
            [appendButtons]="[
              {
                icon: unattendedPasswordInputType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash',
                id: 'changePasswordType',
                type: 'secondary'
              }
            ]"
            formControlName="password"></mbs-input>
        </div>
      </div>
    </ng-container>

    <div class="row mt-3">
      <div class="col">
        <mbs-select
          [items]="joinSessionModeSelectItems"
          [boldLabel]="true"
          [bindValue]="'value'"
          [bindLabel]="'label'"
          [label]="'shared:agentOptions.connectOptions.securityJoinSessionModeSelectLabel' | i18next"
          [searchable]="false"
          [clearable]="false"
          formControlName="joinSessionMode"></mbs-select>
      </div>
      <div class="col-3">
        <mbs-select
          *ngIf="isPinLengthVisible()"
          [boldLabel]="true"
          [items]="pinLengthSelectItems"
          [label]="'shared:agentOptions.connectOptions.securityPinLengthSelectLabel' | i18next"
          [clearable]="false"
          [searchable]="false"
          formControlName="pinLength"></mbs-select>
      </div>
    </div>
  </ng-container>

  <ng-container
    [ngTemplateOutlet]="sectionTitle"
    [ngTemplateOutletContext]="{
      title: 'shared:agentOptions.connectOptions.sessionOptions' | i18next
    }">
  </ng-container>

  <h5
    class="my-2 fw-bold"
    [class.-disabled]="form.disabled">
    {{ 'shared:agentOptions.connectOptions.unattendedAccess' | i18next }}
  </h5>

  <ng-container formGroupName="inputControl">
    <mbs-checkbox
      [label]="'shared:agentOptions.connectOptions.blackScreen' | i18next"
      formControlName="blackScreen"></mbs-checkbox>

    <mbs-checkbox
      [label]="'shared:agentOptions.connectOptions.lockInput' | i18next"
      formControlName="lockInput"></mbs-checkbox>
  </ng-container>

  <ng-container formGroupName="unattendedAccessDisconnect">
    <div class="form-row my-3">
      <div class="col-12">
        <mbs-select
          [items]="unattendedAccessDisconnectOptions"
          [label]="'shared:agentOptions.connectOptions.unattendedAccessDisconnectMode.label' | i18next"
          [boldLabel]="true"
          [bindValue]="'value'"
          [bindLabel]="'label'"
          [clearable]="false"
          [searchable]="false"
          formControlName="mode"></mbs-select>
      </div>
    </div>
  </ng-container>

  <h5
    class="my-2 fw-bold"
    [class.-disabled]="form.disabled">
    {{ 'shared:agentOptions.connectOptions.inactivity' | i18next }}
  </h5>

  <ng-container formGroupName="disconnectIfInactive">
    <mbs-checkbox
      [label]="'shared:agentOptions.connectOptions.disconnectIfInactive.enabled' | i18next"
      formControlName="enabled"></mbs-checkbox>

    <div class="form-row mt-2 ml-4">
      <div class="col-4">
        <mbs-number
          [min]="1"
          [imaskOpts]="{
            mask: Number,
            scale: 0
          }"
          formControlName="interval"></mbs-number>
      </div>

      <div class="col-4">
        <mbs-select
          [items]="timeUnits"
          [bindValue]="'value'"
          [bindLabel]="'label'"
          [clearable]="false"
          [searchable]="false"
          formControlName="intervalUnits"></mbs-select>
      </div>
    </div>
  </ng-container>

  <ng-container
    [ngTemplateOutlet]="sectionTitle"
    [ngTemplateOutletContext]="{ title: 'shared:agentOptions.connectOptions.endUserOptions' | i18next }">
  </ng-container>

  <ng-container formGroupName="managedSystem">
    <mbs-checkbox
      [label]="'shared:agentOptions.connectOptions.securityAllowGuiLabel' | i18next"
      formControlName="allowGui"></mbs-checkbox>
    <mbs-checkbox
      class="mt-2"
      [label]="'shared:agentOptions.connectOptions.securityAllowOutgoingConnectionsLabel' | i18next"
      formControlName="allowOutgoingConnections"></mbs-checkbox>
  </ng-container>

  <ng-container formGroupName="configPassword">
    <mbs-checkbox
      [label]="'shared:agentOptions.connectOptions.configPasswordLabel' | i18next"
      formControlName="enabled">
      <ng-container appendLabel>
        <span
          class="ico ico-info-circle tooltip-btn text-info"
          [ngbTooltip]="'shared:agentOptions.connectOptions.configPasswordInfo' | i18next"
          container="body">
        </span>
      </ng-container>
    </mbs-checkbox>
    <div
      class="row mt-2"
      *ngIf="isConfigPasswordVisible()">
      <div class="col-9">
        <mbs-input
          [autocomplete]="'off'"
          [name]="'configPassword'"
          [placeholder]="'shared:agentOptions.connectOptions.passwordInputPlaceholder' | i18next"
          [type]="configPasswordInputType"
          (buttonClick)="configPasswordInputType = getPasswordInputType(configPasswordInputType)"
          [appendButtons]="[
            {
              icon: configPasswordInputType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash',
              id: 'changePasswordType',
              type: 'secondary'
            }
          ]"
          formControlName="password">
        </mbs-input>
      </div>
    </div>
  </ng-container>

  <ng-container
    [ngTemplateOutlet]="sectionTitle"
    [ngTemplateOutletContext]="{ title: 'shared:agentOptions.connectOptions.updatesAndLogging' | i18next }">
  </ng-container>

  <div
    class="mbs-form-group"
    formGroupName="update">
    <mbs-switcher
      [label]="'shared:agentOptions.connectOptions.appAutoUpdateCheckbox' | i18next"
      formControlName="auto">
      <ng-container appendLabel>
        <div class="d-flex align-items-center">
          <span
            class="ico ico-info-circle tooltip-btn text-info"
            [ngbTooltip]="'shared:agentOptions.connectOptions.appAutoUpdateInfoText' | i18next"
            container="body"></span>
        </div>
      </ng-container>
    </mbs-switcher>
  </div>

  <div
    class="mbs-form-group"
    formGroupName="logger">
    <mbs-select
      [items]="loggingLevelSelectItems"
      [boldLabel]="true"
      [bindLabel]="'label'"
      [bindValue]="'value'"
      [clearable]="false"
      [searchable]="false"
      [label]="'shared:agentOptions.connectOptions.loggingLevelSelectLabel' | i18next"
      formControlName="level"></mbs-select>
  </div>

  <ng-container
    [ngTemplateOutlet]="sectionTitle"
    [ngTemplateOutletContext]="{ title: 'shared:agentOptions.connectOptions.proxySectionHeader' | i18next }">
  </ng-container>

  <div
    class="mbs-form-group"
    formGroupName="proxy">
    <mbs-select
      [items]="proxyModeSelectItems"
      [boldLabel]="true"
      [bindValue]="'value'"
      [bindLabel]="'label'"
      [clearable]="false"
      [searchable]="false"
      [label]="'shared:agentOptions.connectOptions.proxyModeSelectLabel' | i18next"
      formControlName="mode"></mbs-select>
    <div
      class="row mt-2"
      *ngIf="isProxyServerHostVisible()">
      <div class="col">
        <mbs-input
          [label]="'shared:agentOptions.connectOptions.proxyHostLabel' | i18next"
          [autocomplete]="'off'"
          [name]="'proxyHost'"
          [placeholder]="'shared:agentOptions.connectOptions.proxyHostDescription' | i18next"
          [type]="'text'"
          formControlName="host"></mbs-input>
      </div>
      <div class="col-3">
        <mbs-number
          [label]="'shared:agentOptions.connectOptions.proxyPortLabel' | i18next"
          [imaskOpts]="{
            mask: Number,
            scale: 0
          }"
          [min]="1"
          [max]="65535"
          formControlName="port"></mbs-number>
      </div>
    </div>
    <mbs-form-group
      class="mt-3"
      *ngIf="isUseBasicAuthSectionVisible()">
      <mbs-checkbox
        [label]="'shared:agentOptions.connectOptions.proxyUseBasicAuthLabel' | i18next"
        formControlName="useBasicAuth"></mbs-checkbox>

      <div
        class="row mt-3"
        *ngIf="isUseBasicAuthUserPasswordSectionVisible()">
        <div class="col-9">
          <mbs-input
            [label]="'shared:agentOptions.connectOptions.proxyUseBasicAuthUserNameLabel' | i18next"
            [boldLabel]="true"
            [showRequiredMark]="false"
            [autocomplete]="'off'"
            [placeholder]="'shared:agentOptions.connectOptions.userNameInputPlaceholder' | i18next"
            [name]="'proxyBasicAuthUserName'"
            type="text"
            formControlName="basicAuthUserName"></mbs-input>
        </div>

        <div class="col-9 mt-2">
          <mbs-input
            [label]="'shared:agentOptions.connectOptions.proxyUseBasicAuthPasswordLabel' | i18next"
            [boldLabel]="true"
            [showRequiredMark]="false"
            [autocomplete]="'off'"
            [name]="'proxyBasicAuthPassword'"
            [placeholder]="'shared:agentOptions.connectOptions.passwordInputPlaceholder' | i18next"
            [type]="basicAuthPasswordInputType"
            (buttonClick)="basicAuthPasswordInputType = getPasswordInputType(basicAuthPasswordInputType)"
            [appendButtons]="[
              {
                icon: basicAuthPasswordInputType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash',
                id: 'changePasswordType',
                type: 'secondary'
              }
            ]"
            formControlName="basicAuthPassword"></mbs-input>
        </div>
      </div>
    </mbs-form-group>
  </div>
</form>

<ng-template
  #sectionTitle
  let-title="title"
  let-withoutSeparator="withoutSeparator">
  <ng-container *ngIf="mode === viewModeEnum.Page">
    <h2
      class="my-3 fw-bold"
      [class.-disabled]="form.disabled">
      {{ title }}
    </h2>
  </ng-container>

  <ng-container *ngIf="mode === viewModeEnum.Panel">
    <hr
      *ngIf="!withoutSeparator"
      class="mt-4 mb-0" />
    <h4
      class="my-3 fw-bold"
      [class.-disabled]="form.disabled">
      {{ title }}
    </h4>
  </ng-container>
</ng-template>
